import { styled, Progress as TGProgress, View, ViewProps } from "tamagui";

const ProgressBase = styled(TGProgress, {
  name: "ProgressBase",
  width: "100%",
  variants: {
    variant: {
      default: {
        backgroundColor: "$gray-100",
      },
      success: {
        backgroundColor: "$gray-100",
      },
      warning: {
        backgroundColor: "$gray-100",
      },
      danger: {
        backgroundColor: "$gray-100",
      },
      score: {
        backgroundColor: "$gray-100",
      },
    },
    size: {
      lg: {
        height: "$0.5",
      },
      md: {
        height: "$0.25",
      },
    },
    rounded: {
      lg: {
        borderRadius: "$1",
      },
    },
  } as const,
  defaultVariants: {
    variant: "default",
    size: "md",
    rounded: "lg",
  },
});
const Indicator = styled(TGProgress.Indicator, {
  name: "Indicator",
  variants: {
    variant: {
      default: {
        backgroundColor: "$gray-primary-900",
      },
      success: {
        backgroundColor: "$score-10-9",
      },

      warning: {
        backgroundColor: "$warning-500",
      },

      danger: {
        backgroundColor: "$darkpink-500",
      },
      score: {
        backgroundColor: "$score-3",
      },
    },
    rounded: {
      lg: {
        borderRadius: "$1",
      },
    },
  } as const,
  defaultVariants: {
    variant: "default",
    rounded: "lg",
  },
});

export type ProgressProps = React.ComponentProps<typeof ProgressBase>;

export const Progress: React.FC<ProgressProps> = ({
  variant = "default",
  rounded = "lg",
  ...rest
}) => {
  return (
    <ProgressBase variant={variant} rounded={rounded} {...rest}>
      <Indicator variant={variant} rounded={rounded} />
    </ProgressBase>
  );
};

const StepIndicator = styled(View, {
  name: "StepIndicator",
  height: "$0.5",
  flex: 1,
  variants: {
    active: {
      true: {
        backgroundColor: "$green-500",
      },
      false: {
        backgroundColor: "$gray-teal-100",
      },
    },
    rounded: {
      left: {
        borderTopLeftRadius: "$5",
        borderBottomLeftRadius: "$5",
      },
      right: {
        borderTopRightRadius: "$5",
        borderBottomRightRadius: "$5",
      },
    },
  } as const,
  defaultVariants: {
    active: false,
  },
});

const resolveActive = (current: number, index: number) => index < current;
const resolveRoundedSide = (steps: number, index: number) => {
  if (index === 0) return "left";
  if (index === steps - 1) return "right";
  return undefined;
};

export const StepProgress: React.FC<
  {
    steps: number;
    current: number;
  } & ViewProps
> = ({ steps, current, ...rest }) => {
  return (
    <View flexDirection="row" gap={"$0.5"} flex={steps} {...rest}>
      {Array.from({ length: steps }).map((_, i) => (
        <StepIndicator
          key={i}
          active={resolveActive(current, i)}
          rounded={resolveRoundedSide(steps, i)}
        />
      ))}
    </View>
  );
};
